import "core-js/modules/es7.symbol.async-iterator";
import "core-js/modules/es6.symbol";
import "regenerator-runtime/runtime";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.string.iterator";
import "core-js/modules/es6.map";
import _classCallCheck from "/home/jorge/Trabajo/Limesurvey/assets/packages/datasecuritysettings/node_modules/@babel/runtime-corejs2/helpers/esm/classCallCheck";
import _createClass from "/home/jorge/Trabajo/Limesurvey/assets/packages/datasecuritysettings/node_modules/@babel/runtime-corejs2/helpers/esm/createClass";

/**
 * @license Copyright (c) 2003-2019, CKSource - Frederico Knabben. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
 */

/**
 * @module ui/componentfactory
 */
import CKEditorError from '@ckeditor/ckeditor5-utils/src/ckeditorerror';
/**
 * A helper class implementing the UI component ({@link module:ui/view~View view}) factory.
 *
 * It allows functions producing specific UI components to be registered under their unique names
 * in the factory. A registered component can be then instantiated by providing its name.
 * Note that names are case insensitive.
 *
 *		// The editor provides localization tools for the factory.
 *		const factory = new ComponentFactory( editor );
 *
 *		factory.add( 'foo', locale => new FooView( locale ) );
 *		factory.add( 'bar', locale => new BarView( locale ) );
 *
 *		// An instance of FooView.
 *		const fooInstance = factory.create( 'foo' );
 *
 *		// Names are case insensitive so this is also allowed:
 *		const barInstance = factory.create( 'Bar' );
 *
 * The {@link module:core/editor/editor~Editor#locale editor locale} is passed to the factory
 * function when {@link module:ui/componentfactory~ComponentFactory#create} is called.
 */

var ComponentFactory =
/*#__PURE__*/
function () {
  /**
   * Creates an instance of the factory.
   *
   * @constructor
   * @param {module:core/editor/editor~Editor} editor The editor instance.
   */
  function ComponentFactory(editor) {
    _classCallCheck(this, ComponentFactory);

    /**
     * The editor instance that the factory belongs to.
     *
     * @readonly
     * @member {module:core/editor/editor~Editor}
     */
    this.editor = editor;
    /**
     * Registered component factories.
     *
     * @private
     * @member {Map}
     */

    this._components = new Map();
  }
  /**
   * Returns an iterator of registered component names. Names are returned in lower case.
   *
   * @returns {Iterable.<String>}
   */


  _createClass(ComponentFactory, [{
    key: "names",
    value:
    /*#__PURE__*/
    regeneratorRuntime.mark(function names() {
      var _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, value;

      return regeneratorRuntime.wrap(function names$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _iteratorNormalCompletion = true;
              _didIteratorError = false;
              _iteratorError = undefined;
              _context.prev = 3;
              _iterator = this._components.values()[Symbol.iterator]();

            case 5:
              if (_iteratorNormalCompletion = (_step = _iterator.next()).done) {
                _context.next = 12;
                break;
              }

              value = _step.value;
              _context.next = 9;
              return value.originalName;

            case 9:
              _iteratorNormalCompletion = true;
              _context.next = 5;
              break;

            case 12:
              _context.next = 18;
              break;

            case 14:
              _context.prev = 14;
              _context.t0 = _context["catch"](3);
              _didIteratorError = true;
              _iteratorError = _context.t0;

            case 18:
              _context.prev = 18;
              _context.prev = 19;

              if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
              }

            case 21:
              _context.prev = 21;

              if (!_didIteratorError) {
                _context.next = 24;
                break;
              }

              throw _iteratorError;

            case 24:
              return _context.finish(21);

            case 25:
              return _context.finish(18);

            case 26:
            case "end":
              return _context.stop();
          }
        }
      }, names, this, [[3, 14, 18, 26], [19,, 21, 25]]);
    })
    /**
     * Registers a component factory function that will be used by the
     * {@link #create create} method and called with the
     * {@link module:core/editor/editor~Editor#locale editor locale} as an argument,
     * allowing localization of the {@link module:ui/view~View view}.
     *
     * @param {String} name The name of the component.
     * @param {Function} callback The callback that returns the component.
     */

  }, {
    key: "add",
    value: function add(name, callback) {
      if (this.has(name)) {
        /**
         * The item already exists in the component factory.
         *
         * @error componentfactory-item-exists
         * @param {String} name The name of the component.
         */
        throw new CKEditorError('componentfactory-item-exists: The item already exists in the component factory.', this, {
          name: name
        });
      }

      this._components.set(getNormalized(name), {
        callback: callback,
        originalName: name
      });
    }
    /**
     * Creates an instance of a component registered in the factory under a specific name.
     *
     * When called, the {@link module:core/editor/editor~Editor#locale editor locale} is passed to
     * the previously {@link #add added} factory function, allowing localization of the
     * {@link module:ui/view~View view}.
     *
     * @param {String} name The name of the component.
     * @returns {module:ui/view~View} The instantiated component view.
     */

  }, {
    key: "create",
    value: function create(name) {
      if (!this.has(name)) {
        /**
         * The required component is not registered in the component factory. Please make sure
         * the provided name is correct and the component has been correctly
         * {@link #add added} to the factory.
         *
         * @error componentfactory-item-missing
         * @param {String} name The name of the missing component.
         */
        throw new CKEditorError('componentfactory-item-missing: The required component is not registered in the factory.', this, {
          name: name
        });
      }

      return this._components.get(getNormalized(name)).callback(this.editor.locale);
    }
    /**
     * Checks if a component of a given name is registered in the factory.
     *
     * @param {String} name The name of the component.
     * @returns {Boolean}
     */

  }, {
    key: "has",
    value: function has(name) {
      return this._components.has(getNormalized(name));
    }
  }]);

  return ComponentFactory;
}(); //
// Ensures that the component name used as the key in the internal map is in lower case.
//
// @private
// @param {String} name
// @returns {String}


export { ComponentFactory as default };

function getNormalized(name) {
  return String(name).toLowerCase();
}